import { navigate } from '../../../utils/navigation'

import {
  resendEmail,
  verifyRequest,
  types,
  enableResendEmailCTA,
  disableResendEmailCTA
} from './'
import notifications, {
  toastFailure,  toastSuccess
} from '../../../global/notifications'

export const dispatchVerifyRequest = (dispatch, data) =>
  dispatch(verifyRequest(data))

export const dispatchResendEmail = (dispatch) => dispatch(resendEmail())

export default (dispatch) => ({
  verifyEmail: (data) =>
    dispatchVerifyRequest(dispatch, data).then(([_, res]) => {
      if (res.type === types.VERIFY_REQUEST_SUCCESS) {
        navigate('/')
        toastSuccess(notifications.emailVerified)
      } else
        toastFailure(notifications.emailVerified, res.payload)
    }),
  resendEmail: () => {
    dispatch(disableResendEmailCTA())
    return dispatchResendEmail(dispatch).then(([_, res]) => {
      dispatch(enableResendEmailCTA())
      if (res.type === types.RESEND_EMAIL_SUCCESS)
        toastSuccess(notifications.resendVerifyEmail)
      else
        toastFailure(notifications.resendVerifyEmail, res.payload)
    })
  }
})
